(function () {
  function initFooter(footer) {
    if (!footer || footer.dataset.kootaFooterReady === 'true') return;
    footer.dataset.kootaFooterReady = 'true';

    var media = window.matchMedia('(max-width: 749px)');
    var menus = Array.prototype.slice.call(footer.querySelectorAll('[data-kf-menu]'));
    var openFirst = footer.dataset.openFirstMobile === 'true';

    function syncMenus() {
      menus.forEach(function (menu, index) {
        if (media.matches) {
          if (!menu.dataset.mobileReady) {
            menu.open = openFirst && index === 0;
            menu.dataset.mobileReady = 'true';
          }
        } else {
          menu.open = true;
          delete menu.dataset.mobileReady;
        }
      });
    }

    menus.forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        if (!media.matches || !menu.open) return;
        menus.forEach(function (otherMenu) {
          if (otherMenu !== menu) otherMenu.open = false;
        });
      });
    });

    footer.querySelectorAll('[data-kf-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });

    var newsletterForm = footer.querySelector('.kf-newsletter__form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function () {
        if (!newsletterForm.checkValidity()) return;
        var submitButton = newsletterForm.querySelector('[data-kf-newsletter-submit]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }
      });
    }

    var revealItems = Array.prototype.slice.call(footer.querySelectorAll('[data-kf-reveal]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    }

    syncMenus();
    if (typeof media.addEventListener === 'function') media.addEventListener('change', syncMenus);
    else if (typeof media.addListener === 'function') media.addListener(syncMenus);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-koota-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
